export default "__VITE_ASSET__B$BL1edk__"